'use strict';
angular.module('sharedConfig', [])
.constant('accountConfig', {
  imprintUrls: {
    dsa: 'https://www.dsa.de/de/impressum.html',
    default: 'https://www.dsa.de/de/impressum.html'
  },
  dataPrivacyUrls: {
    dsa: 'https://www.dsa.de/de/datenschutzerklaerung.html',
    sph: window.location.origin + '/sph-privacy-policy-3a33806c.html',
    default: 'https://www.dsa.de/de/datenschutzerklaerung.html'
  }
});


// WEBPACK FOOTER //
// ./.tmp/components/common/constants/accountprovider.js